import { colors } from '@lmc/common/constants'
import dayjs from 'dayjs'
import chartTitles from '../chartTitles'
import withToolbar from '../withToolbar'
import LineChart from './LineChart'

const moods = {
  1: 'Very Bad',
  2: 'Bad',
  3: 'Neutral',
  4: 'Good',
  5: 'Very Good'
}

export default withToolbar(LineChart, {
  pdfExport: {
    title: chartTitles.mood
  },
  timeWindow: 7 * 4,
  childProps: {
    type: 'mood',
    yAxisMin: 1,
    yMin: 1,
    yAxisCategories: [
      ``,
      `<div style="font-weight: bold; color: ${colors.red}">${moods[1]}</div>`,
      `<div style="font-weight: bold; color: ${colors.yellow}">${moods[2]}</div>`,
      `<div style="font-weight: bold; color: ${colors.darkgrey}">${moods[3]}</div>`,
      `<div style="font-weight: bold; color: ${colors.green}">${moods[4]}</div>`,
      `<div style="font-weight: bold; color: ${colors.green}">${moods[5]}</div>`
    ],
    yAllowDecimals: false,
    yAxisLabel: 'Mood Score',
    title: 'Mood Chart',
    // subTitle: '1 = Very Bad, 2 = Bad, 3 = Neutral, 4 = Good, 5 = Very Good',
    tooltip: {
      formatter() {
        return `<strong style="font-size: 10px; opacity: 0.7;">${dayjs(
          this.x
        ).format('dddd Do MMMM YYYY')}</strong><br /> Mood was <strong>${
          moods[this.y]
        }</strong>`
      }
    }
  }
})
